/**
 * Product Page
 * Replica for showroom.dotpe.in/[domain]
 */
import React, { useEffect } from 'react';
import Home from '@/containers/Home';
import Layout from '@/components/Layout';
import { fetchStoreInfo, getCatalogCategories, getThemeById } from '../../../services';
import { getMetaDescription } from '@/utils/getMetaDescription';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { fetchDomainFromHeaders } from '@/utils/fetchDomainFromHeaders';
import { useDispatch, useSelector } from 'react-redux';
import 'url-search-params-polyfill';
import { emptyCart } from '@/redux/actions';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';

const Product = (props) => {
  const dispatch = useDispatch();
  const storeData = useSelector((state) => state.storeReducer.store);

  useEffect(() => {
    if (props.storeInfo.store_id !== storeData.store_id) {
      dispatch(emptyCart());
    }
  }, []);

  return (
    <Layout
      store={props.storeInfo}
      title={`${props.storeInfo.store_info.name}${
        props.storeInfo.address.city ? `, ${props.storeInfo.address.city}` : ''
      } - Order Online`}
      Icon={props.storeInfo.store_info.logo_image}
      metaDescription={getMetaDescription(props.storeInfo)}
      OGImage={props.storeInfo.store_info.logo_image}
      isCustomDomain={props.isCustomDomain}
    >
      <Home {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};

  const { tid } = ctx.query;

  const propData = {
    storeInfo: {},
    catalogCategories: [],
    isCustomDomain: false,
  };

  const { isCustomDomain } = fetchDomainFromHeaders(ctx);
  propData.isCustomDomain = isCustomDomain;
  const storeResponse = await fetchStoreInfo({ ctx });
  if (storeResponse.data && storeResponse.data.status) {
    propData.storeInfo = JSON.parse(JSON.stringify(storeResponse.data.store));

    if (
      typeof ctx.req?.headers?.host == 'string' &&
      ctx.req?.headers?.host.indexOf('preview') > -1 &&
      tid
    ) {
      const themeResponse = await getThemeById(tid, storeResponse?.data?.store?.store_id);
      if (themeResponse.data && themeResponse.data.status) {
        propData.storeInfo = {
          ...propData.storeInfo,
          theme: themeResponse.data.theme || null,
        };
      }
    }

    const categoriesResponse = await getCatalogCategories(
      storeResponse.data.store.store_id
    );
    if (categoriesResponse.data && categoriesResponse.data.status) {
      propData.catalogCategories =
        JSON.parse(JSON.stringify(categoriesResponse.data.store_categories)) || [];
    }
  } else {
    ctx.res.writeHead(302, { location: '/404' });
    ctx.res.end();
    return { props: {} };
  }

  const extraProps = getRequiredCtxProps(ctx);

  return { props: { ...propData, ...extraProps } };
}

export default Product;
